import React, { useState } from "react";
// react plugin used to create DropdownMenu for selecting items
import { Dots } from 'react-preloaders';

// reactstrap components
import {
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import DropdownFixedNavbar from "pincelit/components/Navbar.js";
import AboutUsHeader from "pincelit/components/PageHeader.js";
import Footer from "pincelit/components/Footer.js";

// Context
import { DataContextConsumer } from "services/dataContext.js";

// Utils
import Functions from 'pincelit/utils/functions.js';

function Partners() {
  React.useEffect(() => {
    document.body.classList.add("about-us");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    return function cleanup() {
      document.body.classList.remove("about-us");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);
  return (
    <DataContextConsumer>
      {context => (
        <React.Fragment>
          <DropdownFixedNavbar />
          <div className="wrapper about-us-styles">
            <AboutUsHeader image={require("assets/img/banners/3.png")} title="No trabajamos solos" subtitle="Una gran comunidad al servicio de los Gobiernos Locales." />
            <div className="section pb-6" id="equipo">
              <div className="about-team team-4 pb-0 pt-0">
                <Container>
                  <Row id="alianzas">
                    <Col className="mb-3" md="12">
                      <p className="mb-5">
                        Paradiplomacia.org es parte de una comunidad internacional de organizaciones que trabajan para y por los gobiernos locales. Nuestros aliados nos apoyan, nos inspiran, nos enseñan y son nuestros socios estratégicos en cada proyecto.
                      </p>
                      <h2 className="title pt-0">Nuestras alianzas</h2>
                      <div className="supportus-line">
                        <Container>
                          <Row>
                            {
                              context.data.partners ?
                                (context.data.partners).map((item, i) =>
                                  item.Partner === 'Nuestras alianzas' &&
                                  <Col xs="6" sm="6" md="2" className="brand-wrapper">
                                    <a href={item.Url} rel="noopener noreferrer" target="_blank">
                                      <img
                                        alt="..."
                                        className="img"
                                        src={Functions.getDriveImages(item.Logo)}
                                      ></img>
                                    </a>
                                  </Col>
                                ) :
                                <Col className="ml-auto mr-auto" md="8">
                                  <div className="section-description text-center">
                                    <h4>No se encontraron partners</h4>
                                  </div>
                                </Col>
                            }
                          </Row>
                        </Container>
                      </div>
                    </Col>
                  </Row>
                  <Row id="apoyan">
                    <Col className="mb-3" md="12">
                      <h2 className="title">Nos apoyan</h2>
                      <div className="supportus-line">
                        <Container>
                          <Row>
                            {
                              context.data.partners ?
                                (context.data.partners).map((item, i) =>
                                  item.Partner === 'Nos apoyan' &&
                                  <Col xs="6" sm="6" md="2" className="brand-wrapper">
                                    <a href={item.Url} rel="noopener noreferrer" target="_blank">
                                      <img
                                        alt="..."
                                        className="img"
                                        src={Functions.getDriveImages(item.Logo)}
                                      ></img>
                                    </a>
                                  </Col>
                                ) :
                                <Col className="ml-auto mr-auto" md="8">
                                  <div className="section-description text-center">
                                    <h4>No se encontraron partners</h4>
                                  </div>
                                </Col>
                            }
                          </Row>
                        </Container>
                      </div>
                    </Col>
                  </Row>
                  <Row id="confían">
                    <Col className="mb-3" md="12">
                      <h2 className="title">Confían en nosotros</h2>
                      <div className="supportus-line">
                        <Container>
                          <Row>
                            {
                              context.data.partners ?
                                (context.data.partners).map((item, i) =>
                                  item.Partner === 'Confían en nosotros' &&
                                  <Col xs="6" sm="6" md="2" className="brand-wrapper">
                                    <a href={item.Url} rel="noopener noreferrer" target="_blank">
                                      <img
                                        alt="..."
                                        className="img"
                                        src={Functions.getDriveImages(item.Logo)}
                                      ></img>
                                    </a>
                                  </Col>
                                ) :
                                <Col className="ml-auto mr-auto" md="8">
                                  <div className="section-description text-center">
                                    <h4>No se encontraron partners</h4>
                                  </div>
                                </Col>
                            }
                          </Row>
                        </Container>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
            <Footer />
            {/* <Dots customLoading={context.loading} color={'#FFFFFF'} /> */}
          </div>
        </React.Fragment>
      )}
    </DataContextConsumer>
  );
}

export default Partners;
